<template>
  <el-container direction="vertical" style="height: 100%;">
    <el-row>
      <el-col :span="5">
        <el-input v-model="params.parameter_name" prefix-icon="el-icon-search" placeholder="输入参数名称查询" @change="onSearch" clearable />
      </el-col>
      <el-col :span="5">
        <el-select v-model="params.parameter_value_type" placeholder="选择数据类型查询" @change="onSearch" clearable>
          <el-option
            v-for="item in numericTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="9" class="col_pos_right" align="right">
        <el-button v-permission="'一键导入参数'" @click="importParams">一键导入参数</el-button>
        <el-button v-permission="'新增参数'" icon="el-icon-plus" @click="addParams()">新增参数</el-button>
        <el-button class="btn btn_1" @click="onSearch()">刷新</el-button>
      </el-col>
    </el-row>

    <el-table :data="pageData.items" stripe border :height="$setTableHeight(1, 0)" :header-cell-style="{textAlign: 'center'}" :cell-style="{textAlign: 'center'}">
      <el-table-column v-for="it in tableColList" :key="it.key" :label="it.name" :fixed="it.fixed">
        <template slot-scope="scope">
          <span v-if="it.key === 'parameter_roles_desp'">{{scope.row[it.key] ? scope.row[it.key].join(',') : ''}}</span>
          <span v-else>{{scope.row[it.key]}}</span>
        </template>
      </el-table-column>

      <el-table-column fixed="right" width="160" label="操作">
        <template slot-scope="scope">
          <el-link v-for="item in $operationsFilter(operations)" :key="item.key" :type="item.type" @click="handleClick(item.operation, scope.row)">{{ item.title }}</el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      background
      style="margin-top:14px"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageData.total"
      :current-page="pageData.page"
      @current-change="onPageChange"
      :page-size="params.max_results"
      :page-sizes="$pageSizes"
      @size-change="onPageSizeChange">
    </el-pagination>

    <el-dialog width="600px" :title="title" :visible.sync="dialogVisible" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" @closed="componet_select = ''">
      <component :is="componet_select" :deviceTypeId="deviceTypeId" :deviceModelId="deviceModelId" :rowData="rowData" :roleList="share.roleList" :parameterTypeTree="parameterTypeTree" @tableCloseDialog="dialogVisible = false" />
    </el-dialog>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
import BasicDataHelper from '@/api/basic_data_helper'
import paramsAdd from './add.vue'
import paramsEdit from './edit.vue'
import paramsImport from './import.vue'

export default {
  data () {
    const deviceModelId = this.deviceModelId
    return Backend.initListPageNoCache(this, 'device_model_parameter', {
      route_name: '参数列表',
      id_name: 'device_model_parameter_id',
      numericTypes: BasicDataHelper.numericTypes,
      parameterTypeTree: [],
      tableColList: [
        {
          key: 'parameter_id',
          name: '参数ID',
          fixed: true
        },
        {
          key: 'parameter_type1_desp',
          name: '参数I类'
        },
        {
          key: 'parameter_type2_desp',
          name: '参数II类'
        },
        {
          key: 'parameter_type3_desp',
          name: '参数III类'
        },
        {
          key: 'parameter_name',
          name: '参数名称'
        },
        {
          key: 'parameter_desp',
          name: '参数说明'
        },
        {
          key: 'parameter_value_type_desp',
          name: '数据类型'
        },
        {
          key: 'parameter_default_value',
          name: '参数默认值'
        },
        {
          key: 'parameter_roles_desp',
          name: '控制角色'
        }
      ],
      operations: [
        {
          key: 'edit',
          title: '编辑',
          icon: 'icon-bianji icon_1',
          permiss: '编辑参数',
          type: 'primary',
          operation: 'editRow'
        },
        {
          key: 'delete',
          title: '删除',
          icon: 'icon-shanchu icon_6',
          permiss: '删除参数',
          type: 'danger',
          operation: 'deleteRow'
        }
      ],
      share: {
        roleList: []
      },
      params: {
        device_model_id: deviceModelId,
        parameter_name: '',
        parameter_value_type: ''
      },
      dialogVisible: false,
      title: '新增参数',
      componet_select: '',
      rowData: {}
    })
  },

  components: {
    'params-add': paramsAdd,
    'params-edit': paramsEdit,
    'params-import': paramsImport
  },

  props: ['deviceTypeId', 'deviceModelId'],

  created () {
    this.getRoleList()
    this.getParameterTypeTree(this.deviceTypeId)
  },

  watch: {
    deviceTypeId (val) {
      this.parameterTypeTree = []
      this.getParameterTypeTree(val)
    },
    deviceModelId (val) {
      console.log(val)
      this.resetTableParams()
      this.params.device_model_id = val
      this.onSearch()
    }
  },
  methods: {
    getRoleList () {
      Backend.filterKeyValueList(this, 'role').then((data) => {
        this.share.roleList = data.filter(item => item.value === '0' || (Number(item.value) >= 3 && Number(item.value) <= 5))
      })
    },
    getParameterTypeTree (id) {
      Backend.post(this, 'device/parameter_type_tree', { device_type_id: id }).then((res) => {
        this.parameterTypeTree = res.items
      })
    },
    importParams () {
      if (this.parameterTypeTree.length < 1) {
        this.$message.warning('此功能暂未开放')
        return
      }
      this.title = '导入参数'
      this.dialogVisible = true
      this.componet_select = 'params-import'
    },
    addParams () {
      if (this.parameterTypeTree.length < 1) {
        this.$message.warning('此功能暂未开放')
        return
      }
      this.title = '新增参数'
      this.dialogVisible = true
      this.componet_select = 'params-add'
    },
    resetTableParams () {
      // console.log(this.pageData)
      for (const k in this.params) {
        this.params[k] = ''
      }
      this.pageData.filter = ''
      this.pageData.first = -1
      this.pageData.items = []
      this.params.max_results = this.pageData.max_results = 10
      this.pageData.page = 0
      this.pageData.total = 0
    },
    onSearch () {
      Backend.queryList(this, this.pageData.filter, 0, this.params)
    },
    onPageChange (v) {
      Backend.queryList(this, this.pageData.filter, v, this.params)
    },
    onPageSizeChange (v) {
      this.params.max_results = v
      Backend.queryList(this, this.pageData.filter, this.pageData.page === 0 ? 1 : this.pageData.page, this.params)
    },
    handleClick (operation, row) {
      this[operation](row)
    },
    editRow (row) {
      this.title = '编辑参数'
      this.dialogVisible = true
      this.componet_select = 'params-edit'
      this.rowData = row
    },
    deleteRow (row) {
      Backend.deleteRow(this, row, '参数')
    }
  }
}
</script>
